export default __webpack_public_path__ + "static/media/the-year-of-hibernation.02b0a2ca.jpg";